import {
  Box,
  Card,
  CardContent,
  Typography,
  Chip,
  Button,
  Stack,
  Paper,
  IconButton,
  Tooltip,
  Grid,
  Avatar,
  CircularProgress,
  Alert,
  Badge,
  Select,
  MenuItem,
  FormControl,
  InputLabel,
  TextField,
  Snackbar,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
} from "@mui/material";
import React, { useState, useEffect } from "react";
import { useLocation, useNavigate, useSearchParams } from "react-router-dom";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import BusinessIcon from "@mui/icons-material/Business";
import CalendarTodayIcon from "@mui/icons-material/CalendarToday";
import NoteIcon from "@mui/icons-material/Note";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import CancelIcon from "@mui/icons-material/Cancel";
import PendingIcon from "@mui/icons-material/Pending";
import AccessTimeIcon from "@mui/icons-material/AccessTime";
import VerifiedIcon from "@mui/icons-material/Verified";
import PhoneIcon from "@mui/icons-material/Phone";
import LanguageIcon from "@mui/icons-material/Language";
import { format } from "date-fns";
import { jobCreatedApis, driverLeaveApis } from "../../../Data/axios";
import config from "../../../Data/AuthUser";

const ViewMoreVacanciesCreated = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [searchParams] = useSearchParams();

  const rowData = location.state;

  // Get page and limit from URL parameters
  const pageParam = searchParams.get('page');
  const limitParam = searchParams.get('limit');
  const [applicants, setApplicants] = useState([]);
  const [applicantsLoading, setApplicantsLoading] = useState(false);
  const [applicantsError, setApplicantsError] = useState(null);
  const [statusFilter, setStatusFilter] = useState("");
  const [dateFilter, setDateFilter] = useState("");
  const [calling, setCalling] = useState({});
  const [webCalling, setWebCalling] = useState({});
  const [notification, setNotification] = useState({
    open: false,
    message: "",
    severity: "success",
  });
  const [rejectDialog, setRejectDialog] = useState({
    open: false,
    applicantId: null,
    remark: "",
  });
  const [remarksDialog, setRemarksDialog] = useState({
    open: false,
    applicant: null,
  });

  console.log("Received rowData:", rowData);

  const {
    id,
    created_at,
    StartLocation,
    EndLocation,
    salary,
    status,
    username,
    user_id,
    image,
    brand,
    wheels,
    model,
    app_user,
    fleet_owner_vehicle,
    Salary,
    Status,
    start_date,
    end_date,
    type,
    reason,
    approved_by,
    approved_at,
    file,
    note,
  } = rowData || {};

  // Helper functions
  const formatDate = (date) => {
    if (!date) return "N/A";
    return format(new Date(date), "dd-MM-yyyy");
  };

  const formatDateTime = (date) => {
    if (!date) return "N/A";
    return format(new Date(date), "dd-MM-yyyy HH:mm");
  };

  const getInitials = (name) => {
    if (!name) return "NA";
    const words = name.split(" ");
    if (words.length === 1) {
      return words[0].substring(0, 2).toUpperCase();
    }
    return (words[0][0] + words[words.length - 1][0]).toUpperCase();
  };

  const convertToPlainText = (htmlContent) => {
    if (!htmlContent) return "";
    const parser = new DOMParser();
    const parsedHtml = parser.parseFromString(htmlContent, "text/html");
    return parsedHtml.body.textContent || "";
  };

  const getStatusInfo = () => {
    const statusValue = Status || status;

    if (typeof statusValue === "string" || Status !== undefined) {
      const jobStatusMap = {
        0: { label: "Inactive", icon: <CancelIcon /> },
        1: { label: "Active", icon: <CheckCircleIcon /> },
        2: { label: "Blocked", icon: <CancelIcon /> },
      };
      return (
        jobStatusMap[statusValue] || { label: "Unknown", icon: <PendingIcon /> }
      );
    }

    const approvalStatusMap = {
      0: { label: "Rejected", icon: <CancelIcon /> },
      1: { label: "Pending", icon: <PendingIcon /> },
      2: { label: "Approved", icon: <CheckCircleIcon /> },
    };
    return (
      approvalStatusMap[statusValue] || {
        label: "Unknown",
        icon: <PendingIcon />,
      }
    );
  };

  const statusInfo = getStatusInfo();

  const handleGoBack = () => {
    // Build URL with page and limit parameters if available
    let backUrl = "/jobs/created";

    // Add page and limit parameters if they exist
    if (pageParam || limitParam) {
      const params = new URLSearchParams();
      if (pageParam) params.append('page', pageParam);
      if (limitParam) params.append('limit', limitParam);
      backUrl += `?${params.toString()}`;
    }

    // Navigate back to jobs list with parameters
    navigate(backUrl);
  };

  // Fetch applicants for this job
  useEffect(() => {
    const fetchApplicants = async () => {
      if (!rowData?.id) return;

      setApplicantsLoading(true);
      setApplicantsError(null);

      try {
        // Build filter parameters
        const params = {};
        if (statusFilter) {
          params.status = statusFilter;
        }
        if (dateFilter) {
          params.applied_at = dateFilter;
        }

        const response = await jobCreatedApis.getApplicationsForOwner(rowData.id, params);
        console.log("🔍 Applicants full response:", JSON.stringify(response, null, 2));
        console.log("🔍 Response type:", typeof response);
        console.log("🔍 Response keys:", response ? Object.keys(response) : "No response");
        console.log("🔍 Is array?", Array.isArray(response));
        console.log("🔍 Response.data:", response.data);

        if (response) {
          // Handle both paginated and non-paginated responses
          let applicantsData;
          if (Array.isArray(response)) {
            applicantsData = response;
            console.log("✅ Response is array, using directly");
          } else if (response.data && Array.isArray(response.data)) {
            applicantsData = response.data;
            console.log("✅ Response.data is array, using response.data");
          } else if (response.current_page !== undefined && Array.isArray(response.data)) {
            applicantsData = response.data;
            console.log("✅ Response is paginated, using response.data");
          } else {
            applicantsData = [];
            console.log("❌ Could not extract applicants array");
          }

          console.log("✅ Applicants data extracted:", applicantsData.length, "applicants");
          if (applicantsData.length > 0) {
            console.log("📋 First applicant sample:", JSON.stringify(applicantsData[0], null, 2));
          }

          // Sort applicants: Pending (1) first, then Accepted (2), then Rejected (0)
          const sortedApplicants = [...applicantsData].sort((a, b) => {
            const statusOrder = { "1": 0, "2": 1, "0": 2 }; // Pending=0, Accepted=1, Rejected=2
            const statusA = statusOrder[a.Status] ?? 3;
            const statusB = statusOrder[b.Status] ?? 3;
            return statusA - statusB;
          });

          setApplicants(sortedApplicants);
        } else {
          setApplicants([]);
        }
      } catch (error) {
        console.error("Error fetching applicants:", error);
        setApplicantsError("Failed to fetch applicants");
      } finally {
        setApplicantsLoading(false);
      }
    };

    fetchApplicants();
  }, [rowData?.id, statusFilter, dateFilter]);

  // Handle applicant selection
  const handleSelectApplicant = async (applicationId) => {
    try {
      const response = await jobCreatedApis.updateJobApplication(applicationId, 2); // 2 = Accepted

      if (response) {
        const updatedApplicants = applicants.map(applicant =>
          applicant.id === applicationId ? { ...applicant, Status: "2" } : applicant
        );
        setApplicants(updatedApplicants);
        setNotification({
          open: true,
          message: response.message || "Applicant accepted successfully",
          severity: "success",
        });
      } else {
        setNotification({
          open: true,
          message: "Failed to accept applicant",
          severity: "error",
        });
      }
    } catch (error) {
      console.error("Error accepting applicant:", error);
      setNotification({
        open: true,
        message: "Failed to accept applicant",
        severity: "error",
      });
    }
  };

  // Handle applicant rejection
  const handleRejectApplicant = async (applicationId, remark = "") => {
    try {
      const response = await jobCreatedApis.rejectJobApplication(applicationId, remark);

      if (response && response.success) {
        const updatedApplicants = applicants.map(applicant =>
          applicant.id === applicationId ? { ...applicant, Status: "0" } : applicant
        );
        setApplicants(updatedApplicants);
        setNotification({
          open: true,
          message: response.message || "Applicant rejected successfully",
          severity: "success",
        });
      } else {
        setNotification({
          open: true,
          message: response?.message || "Failed to reject applicant",
          severity: "error",
        });
      }
    } catch (error) {
      console.error("Error rejecting applicant:", error);
      setNotification({
        open: true,
        message: "Failed to reject applicant",
        severity: "error",
      });
    }
  };

  // Open reject dialog
  const handleOpenRejectDialog = (applicationId) => {
    setRejectDialog({
      open: true,
      applicantId: applicationId,
      remark: "",
    });
  };

  // Close reject dialog
  const handleCloseRejectDialog = () => {
    setRejectDialog({
      open: false,
      applicantId: null,
      remark: "",
    });
  };

  // Handle remark input change
  const handleRemarkChange = (e) => {
    setRejectDialog(prev => ({
      ...prev,
      remark: e.target.value.slice(0, 220), // Limit to 220 characters
    }));
  };

  // Submit rejection with remark
  const handleSubmitReject = () => {
    if (!rejectDialog.remark.trim()) {
      setNotification({
        open: true,
        message: "Please provide a reason for rejection",
        severity: "error",
      });
      return;
    }

    handleRejectApplicant(rejectDialog.applicantId, rejectDialog.remark);
    handleCloseRejectDialog();
  };

  // Open remarks dialog
  const handleOpenRemarksDialog = (applicant) => {
    setRemarksDialog({
      open: true,
      applicant: applicant,
    });
  };

  // Close remarks dialog
  const handleCloseRemarksDialog = () => {
    setRemarksDialog({
      open: false,
      applicant: null,
    });
  };

  // Format rejection details for display
  const formatRejectionDetails = (applicant) => {
    if (!applicant.rejection_reason) return null;

    const rejectedBy = applicant.rejected_by_name || "Admin";
    const rejectedAt = applicant.rejected_at ? convertUTCToLocal(applicant.rejected_at) : "Unknown time";

    return {
      reason: applicant.rejection_reason,
      rejectedBy: rejectedBy,
      rejectedAt: rejectedAt,
    };
  };

  // Convert UTC to local time
  const convertUTCToLocal = (utcDateString) => {
    if (!utcDateString) return "N/A";
    const utcDate = new Date(utcDateString);
    return format(utcDate, "dd-MM-yyyy HH:mm");
  };

  // Get applicant status display
  const getApplicantStatus = (status) => {
    const statusMap = {
      "0": { label: "Rejected", color: "#f44336", icon: <CancelIcon />, bgColor: "#ffebee" },
      "1": { label: "Pending", color: "#ff9800", icon: <PendingIcon />, bgColor: "#fff3e0" },
      "2": { label: "Accepted", color: "#4caf50", icon: <CheckCircleIcon />, bgColor: "#e8f5e9" },
    };
    return statusMap[status] || statusMap["1"];
  };

  // Get applicant initials
  const getApplicantInitials = (name) => {
    if (!name) return "NA";
    const words = name.split(" ");
    if (words.length === 1) {
      return words[0].substring(0, 2).toUpperCase();
    }
    return (words[0][0] + words[words.length - 1][0]).toUpperCase();
  };

  // Handle call initiation with phone number processing
  const handleCall = async (phoneNumber, applicantId, callType = "m") => {
    if (!phoneNumber || phoneNumber === "N/A") {
      setNotification({
        open: true,
        message: "Phone number not available",
        severity: "error",
      });
      return;
    }

    // Remove "91" prefix if present
    let processedNumber = phoneNumber;
    if (processedNumber.startsWith("91")) {
      processedNumber = processedNumber.substring(2);
    }

    console.log("📞 Call Initiation Details:");
    console.log("Original Phone Number:", phoneNumber);
    console.log("Processed Phone Number:", processedNumber);
    console.log("Applicant ID:", applicantId);
    console.log("Call Type:", callType === "m" ? "Mobile" : "Web");

    if (callType === "m") {
      setCalling(prev => ({ ...prev, [applicantId]: true }));
    } else {
      setWebCalling(prev => ({ ...prev, [applicantId]: true }));
    }

    try {
      console.log("📡 Initiating API call to /callUsers...");
      const response = await driverLeaveApis.callUsers(processedNumber, callType);

      console.log("✅ API Response Received:", response);
      console.log("Response Details:", JSON.stringify(response, null, 2));

      if (response.success) {
        console.log("✅ Call initiated successfully!");
        console.log("Call Data:", response.data);
        setNotification({
          open: true,
          message: callType === "m" ? "Mobile call initiated successfully" : "Web call initiated successfully",
          severity: "success",
        });
      } else {
        console.log("❌ Call initiation failed");
        console.log("Error Message:", response.message);
        setNotification({
          open: true,
          message: response.message || "Failed to initiate call",
          severity: "error",
        });
      }
    } catch (error) {
      console.error("❌ Call initiation error:", error);
      console.error("Error Details:", JSON.stringify(error, null, 2));
      setNotification({
        open: true,
        message: "Failed to initiate call. Please try again.",
        severity: "error",
      });
    } finally {
      console.log("🔄 Calling state reset for applicant:", applicantId);
      if (callType === "m") {
        setCalling(prev => ({ ...prev, [applicantId]: false }));
      } else {
        setWebCalling(prev => ({ ...prev, [applicantId]: false }));
      }
    }
  };

  // Handle applicant card click - navigate to driver details
  const handleApplicantClick = (applicant) => {
    const driverUserId = applicant.appUser?.user_id || applicant.ApplierID;
    console.log("Navigating to driver:", driverUserId);

    if (driverUserId) {
      // Navigate directly - let DriverView handle the API call
      navigate(`/Users/Drivers/${driverUserId}`, {
        state: {
          driverId: driverUserId,
          fromJobDetails: true,
          jobId: id,
          applicantData: applicant
        },
      });
    } else {
      setNotification({
        open: true,
        message: "Driver ID not found",
        severity: "error",
      });
    }
  };

  return (
    <Box
      sx={{
        minHeight: "100vh",
        bgcolor: "#f8f9fa",
        p: 2,
      }}
    >
      {/* Header */}
      <Paper
        elevation={1}
        sx={{
          p: 2,
          mb: 2,
          borderRadius: 2,
          bgcolor: "white",
          border: "1px solid #e0e0e0",
        }}
      >
        <Stack direction="row" alignItems="center" spacing={2} justifyContent="space-between">
          <Stack direction="row" alignItems="center" spacing={2}>
            <Tooltip title="Go Back">
              <IconButton
                onClick={handleGoBack}
                sx={{
                  color: "black",
                  bgcolor: "#f5f5f5",
                  "&:hover": { bgcolor: "#e0e0e0" },
                }}
              >
                <ArrowBackIcon />
              </IconButton>
            </Tooltip>
            <Typography variant="h4" fontWeight="bold" color="black">
              Job Applications
            </Typography>
          </Stack>
          <Chip
            icon={statusInfo.icon}
            label={statusInfo.label}
            size="medium"
            sx={{
              fontWeight: "bold",
              px: 2,
              py: 1,
              color: "black",
              borderColor: "#e0e0e0",
              backgroundColor: "#f5f5f5",
              "& .MuiChip-icon": { color: "black" },
            }}
          />
        </Stack>
      </Paper>

      {/* Compact Job Details Card */}
      <Card
        elevation={1}
        sx={{
          borderRadius: 2,
          bgcolor: "white",
          border: "1px solid #e0e0e0",
          mb: 2,
        }}
      >
        <CardContent sx={{ p: 2 }}>
          <Grid container spacing={2}>
            {/* Left Column - Job Info */}
            <Grid item xs={12} md={6}>
              <Box sx={{ display: "flex", flexDirection: "column", gap: 1.5 }}>
                <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                  <BusinessIcon sx={{ color: "#1d82f5", fontSize: 20 }} />
                  <Box>
                    <Typography variant="caption" color="gray" fontWeight="500">
                      Client
                    </Typography>
                    <Typography variant="body1" fontWeight="600" color="black">
                      {username || app_user?.username || "Not specified"}
                    </Typography>
                  </Box>
                </Box>

                <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                  <CalendarTodayIcon sx={{ color: "#1d82f5", fontSize: 20 }} />
                  <Box>
                    <Typography variant="caption" color="gray" fontWeight="500">
                      Route
                    </Typography>
                    <Typography variant="body1" fontWeight="600" color="black">
                      {StartLocation || "N/A"} → {EndLocation || "N/A"}
                    </Typography>
                  </Box>
                </Box>

                <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                  <CalendarTodayIcon sx={{ color: "#1d82f5", fontSize: 20 }} />
                  <Box>
                    <Typography variant="caption" color="gray" fontWeight="500">
                      Posted
                    </Typography>
                    <Typography variant="body1" fontWeight="600" color="black">
                      {formatDateTime(created_at)}
                    </Typography>
                  </Box>
                </Box>
              </Box>
            </Grid>

            {/* Right Column - Vehicle & Salary */}
            <Grid item xs={12} md={6}>
              <Box sx={{ display: "flex", flexDirection: "column", gap: 1.5 }}>
                <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                  <BusinessIcon sx={{ color: "#1d82f5", fontSize: 20 }} />
                  <Box>
                    <Typography variant="caption" color="gray" fontWeight="500">
                      Vehicle
                    </Typography>
                    <Typography variant="body1" fontWeight="600" color="black">
                      {brand && wheels && model
                        ? `${brand} / ${wheels} wheeler / ${model}`
                        : fleet_owner_vehicle
                        ? `${fleet_owner_vehicle.brand?.brand || ""} / ${
                            fleet_owner_vehicle.model?.model || ""
                          } / ${fleet_owner_vehicle.model?.wheels || ""} wheels`
                        : "Not specified"}
                    </Typography>
                  </Box>
                </Box>

                <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                  <NoteIcon sx={{ color: "#1d82f5", fontSize: 20 }} />
                  <Box>
                    <Typography variant="caption" color="gray" fontWeight="500">
                      Salary
                    </Typography>
                    <Typography variant="body1" fontWeight="600" color="black">
                      {salary || Salary || "Not specified"}
                    </Typography>
                  </Box>
                </Box>

                <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                  <CheckCircleIcon sx={{ color: "#1d82f5", fontSize: 20 }} />
                  <Box>
                    <Typography variant="caption" color="gray" fontWeight="500">
                      Status
                    </Typography>
                    <Typography variant="body1" fontWeight="600" color="black">
                      {status === "1" || Status === "1" ? "Active" : "Closed"}
                    </Typography>
                  </Box>
                </Box>
              </Box>
            </Grid>
          </Grid>
        </CardContent>
      </Card>

      {/* Applicants Section */}
      <Card
        elevation={1}
        sx={{
          borderRadius: 2,
          bgcolor: "white",
          border: "1px solid #e0e0e0",
          flex: 1,
        }}
      >
        <CardContent sx={{ p: 2 }}>
          {/* Filters Section */}
          <Box sx={{ mb: 3 }}>
            <Grid container spacing={2} alignItems="center">
              <Grid item xs={12} sm={6} md={4}>
                <FormControl fullWidth size="small">
                  <InputLabel sx={{ color: "black" }}>Filter by Status</InputLabel>
                  <Select
                    value={statusFilter}
                    label="Filter by Status"
                    onChange={(e) => setStatusFilter(e.target.value)}
                    sx={{
                      color: "black",
                      backgroundColor: "white",
                      "& .MuiOutlinedInput-root": {
                        "& fieldset": {
                          borderColor: "black",
                        },
                        "&:hover:not(.Mui-disabled):not(.Mui-focused) fieldset": {
                          borderColor: "black",
                        },
                        "&.Mui-focused fieldset": {
                          borderColor: "black",
                        },
                        "&.Mui-disabled fieldset": {
                          borderColor: "black",
                        },
                      },
                      "& .MuiSelect-select": {
                        color: "black",
                        backgroundColor: "white",
                      },
                      "& .MuiPaper-root": {
                        backgroundColor: "white",
                      },
                    }}
                    MenuProps={{
                      PaperProps: {
                        sx: {
                          backgroundColor: "white",
                        },
                      },
                    }}
                  >
                    <MenuItem value="" sx={{ color: "black" }}>All Status</MenuItem>
                    <MenuItem value="1" sx={{ color: "black" }}>Pending</MenuItem>
                    <MenuItem value="2" sx={{ color: "black" }}>Accepted</MenuItem>
                    <MenuItem value="0" sx={{ color: "black" }}>Rejected</MenuItem>
                  </Select>
                </FormControl>
              </Grid>
              <Grid item xs={12} sm={6} md={4}>
                <TextField
                  fullWidth
                  size="small"
                  label="Applied After (YYYY-MM-DD)"
                  type="date"
                  value={dateFilter}
                  onChange={(e) => setDateFilter(e.target.value)}
                  InputLabelProps={{
                    shrink: true,
                    sx: { color: "black" },
                  }}
                  InputProps={{
                    sx: {
                      color: "black",
                    },
                  }}
                  sx={{
                    "& .MuiOutlinedInput-root": {
                      "& fieldset": {
                        borderColor: "black",
                      },
                      "&:hover:not(.Mui-disabled):not(.Mui-focused) fieldset": {
                        borderColor: "black",
                      },
                      "&.Mui-focused fieldset": {
                        borderColor: "black",
                      },
                    },
                  }}
                />
              </Grid>
              <Grid item xs={12} sm={12} md={4} sx={{ display: "flex", alignItems: "center" }}>
                {(statusFilter || dateFilter) && (
                  <Button
                    variant="outlined"
                    size="small"
                    startIcon={<CancelIcon />}
                    onClick={() => {
                      setStatusFilter("");
                      setDateFilter("");
                    }}
                    sx={{
                      height: "40px",
                      color: "black",
                      borderColor: "black",
                      fontWeight: 600,
                      "&:hover": {
                        color: "black",
                        borderColor: "black",
                        backgroundColor: "rgba(0,0,0,0.05)",
                      },
                    }}
                  >
                    Clear Filters
                  </Button>
                )}
              </Grid>
            </Grid>
          </Box>

          <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between", mb: 2, mt: 2 }}>
            <Typography variant="h5" fontWeight="600" color="black">
              Applicants ({applicants.length})
            </Typography>
            {applicants.length > 0 && (
              <Box sx={{ display: "flex", gap: 1, flexWrap: "wrap" }}>
                <Chip
                  label={`Pending: ${applicants.filter(a => a.Status === "1").length}`}
                  size="small"
                  sx={{ backgroundColor: "#fff3e0", color: "#ff9800" }}
                />
                <Chip
                  label={`Accepted: ${applicants.filter(a => a.Status === "2").length}`}
                  size="small"
                  sx={{ backgroundColor: "#e8f5e9", color: "#4caf50" }}
                />
                <Chip
                  label={`Rejected: ${applicants.filter(a => a.Status === "0").length}`}
                  size="small"
                  sx={{ backgroundColor: "#ffebee", color: "#f44336" }}
                />
              </Box>
            )}
          </Box>

          {applicantsLoading ? (
            <Box sx={{ display: "flex", justifyContent: "center", py: 8 }}>
              <CircularProgress />
            </Box>
          ) : applicantsError ? (
            <Alert severity="error" sx={{ mb: 2 }}>
              {applicantsError}
            </Alert>
          ) : applicants.length === 0 ? (
            <Box sx={{ textAlign: "center", py: 8, color: "gray" }}>
              <Typography variant="h6">No applicants yet for this job</Typography>
              <Typography variant="body2" sx={{ mt: 1 }}>
                Applications will appear here when drivers apply
              </Typography>
            </Box>
          ) : (
            <Grid container spacing={2}>
              {applicants.map((applicant) => {
                const applicantStatus = getApplicantStatus(applicant.Status);
                const appUser = applicant.appUser || {};
                const applicantName = appUser.username || "Unknown";
                const applicantImage = appUser.image;
                const applicantUserId = appUser.user_id || applicant.ApplierID || "N/A";
                const applicantPhone = appUser.phone || "N/A";
                const isVerified = appUser.verified === "1" || appUser.verified === 1;
                const appliedAt = applicant.created_at;

                return (
                  <Grid item xs={12} sm={6} md={4} lg={3} key={applicant.id}>
                    <Card
                      elevation={2}
                      onClick={() => handleApplicantClick(applicant)}
                      sx={{
                        height: "100%",
                        border: "1px solid #e0e0e0",
                        transition: "all 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
                        cursor: "pointer",
                        backgroundColor: applicantStatus.bgColor,
                        borderRadius: 2,
                        position: "relative",
                        overflow: "hidden",
                        "&::before": {
                          content: '""',
                          position: "absolute",
                          top: 0,
                          left: 0,
                          right: 0,
                          height: "4px",
                          background: `linear-gradient(90deg, ${applicantStatus.color}, ${applicantStatus.color}88)`,
                          transform: "scaleX(0)",
                          transformOrigin: "left",
                          transition: "transform 0.3s ease",
                        },
                        "&:hover": {
                          transform: "translateY(-6px)",
                          boxShadow: "0 10px 20px rgba(0,0,0,0.15)",
                          borderColor: applicantStatus.color,
                          "&::before": {
                            transform: "scaleX(1)",
                          },
                        },
                      }}
                    >
                      <CardContent sx={{ p: 2 }}>
                        <Box sx={{ display: "flex", flexDirection: "column", gap: 1.5, alignItems: "center" }}>
                          {/* Driver Avatar with Verified Badge */}
                          <Box sx={{ position: "relative", display: "inline-block" }}>
                            {applicantImage ? (
                              <Avatar
                                src={`${config.apiImageUrl}${applicantImage}`}
                                alt={applicantName}
                                sx={{
                                  width: 80,
                                  height: 80,
                                  border: `3px solid ${applicantStatus.color}`,
                                  fontSize: "28px",
                                  fontWeight: "bold",
                                }}
                                onError={(e) => {
                                  e.target.style.display = "none";
                                  const nextSibling = e.target.nextElementSibling;
                                  if (nextSibling) {
                                    nextSibling.style.display = "flex";
                                  }
                                }}
                              />
                            ) : (
                              <Avatar
                                sx={{
                                  width: 80,
                                  height: 80,
                                  border: `3px solid ${applicantStatus.color}`,
                                  fontSize: "28px",
                                  fontWeight: "bold",
                                  background: `linear-gradient(135deg, ${applicantStatus.color} 0%, ${applicantStatus.color}88 100%)`,
                                }}
                              >
                                {getApplicantInitials(applicantName)}
                              </Avatar>
                            )}
                            {isVerified && (
                              <Badge
                                badgeContent={<VerifiedIcon sx={{ fontSize: 18, color: "#4caf50" }} />}
                                anchorOrigin={{
                                  vertical: "bottom",
                                  horizontal: "right",
                                }}
                                sx={{
                                  "& .MuiBadge-badge": {
                                    padding: "0",
                                    backgroundColor: "white",
                                    borderRadius: "50%",
                                    border: "2px solid #4caf50",
                                    width: 28,
                                    height: 28,
                                  },
                                }}
                              />
                            )}
                          </Box>

                          {/* Driver Name */}
                          <Typography
                            variant="h6"
                            fontWeight="700"
                            color="black"
                            textAlign="center"
                            noWrap
                            sx={{ fontSize: "1.1rem", mt: 0.5 }}
                          >
                            {applicantName}
                          </Typography>

                          {/* User ID */}
                          <Typography
                            variant="caption"
                            color="black"
                            textAlign="center"
                            sx={{ fontSize: "0.8rem", fontWeight: 500, mb: 0.5 }}
                          >
                            ID: {applicantUserId}
                          </Typography>

                          {/* Divider */}
                          <Box sx={{ width: "100%", height: "1px", backgroundColor: "rgba(0,0,0,0.1)", my: 0.5 }} />

                          {/* Phone Number - Larger Font with Call Buttons */}
                          <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between", gap: 1, width: "100%" }}>
                            <Box sx={{ display: "flex", alignItems: "center", gap: 0.5 }}>
                              <PhoneIcon sx={{ fontSize: 16, color: "#666" }} />
                              <Typography variant="body2" color="black" sx={{ fontSize: "0.95rem", fontWeight: 600 }}>
                                {applicantPhone}
                              </Typography>
                            </Box>
                            <Box sx={{ display: "flex", gap: 0.5 }}>
                              <IconButton
                                size="small"
                                onClick={(e) => {
                                  e.stopPropagation();
                                  handleCall(applicantPhone, applicant.id, "m");
                                }}
                                disabled={calling[applicant.id]}
                                sx={{
                                  color: "#2196f3",
                                  bgcolor: "rgba(33, 150, 243, 0.1)",
                                  "&:hover": {
                                    bgcolor: "rgba(33, 150, 243, 0.2)",
                                  },
                                  "&:disabled": {
                                    color: "#999",
                                    bgcolor: "rgba(0, 0, 0, 0.1)",
                                  },
                                }}
                              >
                                {calling[applicant.id] ? <CircularProgress size={16} /> : <PhoneIcon sx={{ fontSize: 16 }} />}
                              </IconButton>
                              <IconButton
                                size="small"
                                onClick={(e) => {
                                  e.stopPropagation();
                                  handleCall(applicantPhone, applicant.id, "w");
                                }}
                                disabled={webCalling[applicant.id]}
                                sx={{
                                  color: "#4caf50",
                                  bgcolor: "rgba(76, 175, 80, 0.1)",
                                  "&:hover": {
                                    bgcolor: "rgba(76, 175, 80, 0.2)",
                                  },
                                  "&:disabled": {
                                    color: "#999",
                                    bgcolor: "rgba(0, 0, 0, 0.1)",
                                  },
                                }}
                              >
                                {webCalling[applicant.id] ? <CircularProgress size={16} /> : <LanguageIcon sx={{ fontSize: 16 }} />}
                              </IconButton>
                            </Box>
                          </Box>

                          {/* Applied At */}
                          <Box sx={{ display: "flex", alignItems: "center", gap: 0.5, width: "100%" }}>
                            <AccessTimeIcon sx={{ fontSize: 14, color: "#666" }} />
                            <Typography variant="caption" color="#666" sx={{ fontSize: "0.8rem" }}>
                              {convertUTCToLocal(appliedAt)}
                            </Typography>
                          </Box>

                          {/* Status */}
                          <Chip
                            icon={applicantStatus.icon}
                            label={applicantStatus.label}
                            size="small"
                            sx={{
                              fontWeight: "bold",
                              backgroundColor: `${applicantStatus.color}20`,
                              color: applicantStatus.color,
                              border: `1px solid ${applicantStatus.color}`,
                              "& .MuiChip-icon": {
                                color: applicantStatus.color,
                              },
                              fontSize: "0.75rem",
                              height: 26,
                            }}
                          />

                          {/* Action Buttons - Only show for pending status */}
                          {applicant.Status === "1" && (
                            <Box sx={{ display: "flex", gap: 0.5, width: "100%", mt: 0.5 }}>
                              <Button
                                variant="contained"
                                size="small"
                                startIcon={<CheckCircleIcon />}
                                onClick={(e) => {
                                  e.stopPropagation();
                                  handleSelectApplicant(applicant.id);
                                }}
                                sx={{
                                  flex: 1,
                                  backgroundColor: "#4caf50",
                                  "&:hover": { backgroundColor: "#388e3c" },
                                  textTransform: "none",
                                  fontSize: "0.8rem",
                                  py: 0.5,
                                  minHeight: 36,
                                  fontWeight: 600,
                                }}
                              >
                                Accept
                              </Button>
                              <Button
                                variant="contained"
                                size="small"
                                startIcon={<CancelIcon />}
                                onClick={(e) => {
                                  e.stopPropagation();
                                  handleOpenRejectDialog(applicant.id);
                                }}
                                sx={{
                                  flex: 1,
                                  backgroundColor: "#f44336",
                                  "&:hover": { backgroundColor: "#d32f2f" },
                                  textTransform: "none",
                                  fontSize: "0.8rem",
                                  py: 0.5,
                                  minHeight: 36,
                                  fontWeight: 600,
                                }}
                              >
                                Reject
                              </Button>
                            </Box>
                          )}

                          {/* Rejection Information - Show for rejected status */}
                          {applicant.Status === "0" && applicant.rejection_reason && (
                            <>
                              {/* Show brief rejection info */}
                              <Box
                                sx={{
                                  width: "100%",
                                  p: 1,
                                  backgroundColor: "rgba(244, 67, 54, 0.08)",
                                  borderRadius: 1,
                                  border: "1px solid rgba(244, 67, 54, 0.3)",
                                }}
                              >
                                <Box sx={{ display: "flex", alignItems: "center", gap: 0.5, mb: 0.5 }}>
                                  <CancelIcon sx={{ fontSize: 14, color: "#f44336" }} />
                                  <Typography variant="caption" sx={{ fontSize: "0.75rem", fontWeight: 600, color: "#d32f2f" }}>
                                    Rejected by {applicant.rejected_by_name || "Admin"}
                                  </Typography>
                                </Box>
                                <Typography
                                  variant="caption"
                                  sx={{
                                    fontSize: "0.7rem",
                                    color: "#666",
                                    display: "-webkit-box",
                                    WebkitLineClamp: 2,
                                    WebkitBoxOrient: "vertical",
                                    overflow: "hidden",
                                  }}
                                >
                                  {applicant.rejected_at ? convertUTCToLocal(applicant.rejected_at) : "Unknown time"}
                                </Typography>
                              </Box>

                              {/* Remarks Button */}
                              <Button
                                variant="outlined"
                                size="small"
                                startIcon={<NoteIcon />}
                                onClick={(e) => {
                                  e.stopPropagation();
                                  handleOpenRemarksDialog(applicant);
                                }}
                                sx={{
                                  width: "100%",
                                  mt: 0.5,
                                  color: "#f44336",
                                  borderColor: "#f44336",
                                  backgroundColor: "rgba(244, 67, 54, 0.05)",
                                  textTransform: "none",
                                  fontSize: "0.8rem",
                                  py: 0.5,
                                  minHeight: 36,
                                  fontWeight: 600,
                                  "&:hover": {
                                    backgroundColor: "rgba(244, 67, 54, 0.1)",
                                    borderColor: "#d32f2f",
                                  },
                                }}
                              >
                                Rejected Reason
                              </Button>
                            </>
                          )}
                        </Box>
                      </CardContent>
                    </Card>
                  </Grid>
                );
              })}
            </Grid>
          )}
        </CardContent>
      </Card>

      {/* Notification Snackbar */}
      <Snackbar
        open={notification.open}
        autoHideDuration={4000}
        onClose={() => setNotification({ ...notification, open: false })}
        anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
      >
        <Alert
          onClose={() => setNotification({ ...notification, open: false })}
          severity={notification.severity}
          sx={{ width: "100%" }}
        >
          {notification.message}
        </Alert>
      </Snackbar>

      {/* Reject Remark Dialog */}
      <Dialog
        open={rejectDialog.open}
        onClose={handleCloseRejectDialog}
        maxWidth="sm"
        fullWidth
        PaperProps={{
          sx: {
            borderRadius: 2,
            backgroundColor: "white",
          },
        }}
      >
        <DialogTitle sx={{ fontWeight: "bold", fontSize: "1.2rem", color: "black" }}>
          Reject Application
        </DialogTitle>
        <DialogContent>
          <Typography variant="body2" color="black" sx={{ mb: 2 }}>
            Please provide a reason for rejecting this application.
          </Typography>
          <TextField
            autoFocus
            multiline
            rows={4}
            fullWidth
            label="Rejection Reason"
            value={rejectDialog.remark}
            onChange={handleRemarkChange}
            inputProps={{
              maxLength: 220,
            }}
            helperText={`${rejectDialog.remark.length}/220 characters`}
            InputLabelProps={{
              sx: { color: "black" },
            }}
            InputProps={{
              sx: { color: "black" },
            }}
            sx={{
              "& .MuiOutlinedInput-root": {
                "& fieldset": {
                  borderColor: "#e0e0e0",
                },
                "&:hover:not(.Mui-disabled):not(.Mui-focused) fieldset": {
                  borderColor: "#1d82f5",
                },
                "&.Mui-focused fieldset": {
                  borderColor: "#1d82f5",
                },
              },
              "& .MuiFormHelperText-root": {
                color: "black",
              },
            }}
          />
        </DialogContent>
        <DialogActions sx={{ p: 2, pt: 0 }}>
          <Button
            onClick={handleCloseRejectDialog}
            sx={{
              color: "black",
              "&:hover": {
                backgroundColor: "rgba(0,0,0,0.05)",
              },
            }}
          >
            Cancel
          </Button>
          <Button
            onClick={handleSubmitReject}
            variant="contained"
            disabled={!rejectDialog.remark.trim()}
            sx={{
              backgroundColor: "#f44336",
              color: "white",
              "&:hover": { backgroundColor: "#d32f2f" },
              "&:disabled": {
                backgroundColor: "#ccc",
              },
            }}
          >
            Reject
          </Button>
        </DialogActions>
      </Dialog>

      {/* Remarks Dialog */}
      <Dialog
        open={remarksDialog.open}
        onClose={handleCloseRemarksDialog}
        maxWidth="sm"
        fullWidth
        PaperProps={{
          sx: {
            borderRadius: 2,
            backgroundColor: "white",
          },
        }}
      >
        <DialogTitle sx={{ fontWeight: "bold", fontSize: "1.2rem", color: "black" }}>
          Rejected Reason
        </DialogTitle>
        <DialogContent>
          {remarksDialog.applicant && (
            <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
              {/* Applicant Info */}
              <Box sx={{ p: 2, backgroundColor: "#f5f5f5", borderRadius: 1 }}>
                <Typography variant="h6" sx={{ mb: 0.5, color: "black", fontWeight: 600 }}>
                  {remarksDialog.applicant.appUser?.username || "Unknown Applicant"}
                </Typography>
                <Typography variant="caption" color="black">
                  ID: {remarksDialog.applicant.appUser?.user_id || "N/A"}
                </Typography>
              </Box>

              {/* Rejection Details */}
              <Box sx={{ p: 2, backgroundColor: "rgba(244, 67, 54, 0.08)", borderRadius: 1, border: "1px solid rgba(244, 67, 54, 0.3)" }}>
                <Box sx={{ display: "flex", alignItems: "center", gap: 0.5, mb: 1.5 }}>
                  <CancelIcon sx={{ fontSize: 16, color: "#f44336" }} />
                  <Typography variant="body1" sx={{ fontWeight: 600, color: "black" }}>
                    Rejected by {remarksDialog.applicant.rejected_by_name || "Admin"}
                  </Typography>
                </Box>

                <Box sx={{ display: "flex", alignItems: "center", gap: 0.5, mb: 1.5 }}>
                  <AccessTimeIcon sx={{ fontSize: 16, color: "#666" }} />
                  <Typography variant="body2" color="black">
                    {remarksDialog.applicant.rejected_at
                      ? convertUTCToLocal(remarksDialog.applicant.rejected_at)
                      : "Unknown time"}
                  </Typography>
                </Box>

                <Box sx={{ display: "flex", alignItems: "flex-start", gap: 0.5, mb: 1 }}>
                  <NoteIcon sx={{ fontSize: 16, color: "#1d82f5", mt: 0.3 }} />
                  <Typography variant="body2" sx={{ fontWeight: 600, color: "black" }}>
                    Reason:
                  </Typography>
                </Box>

                <Box sx={{ p: 1.5, backgroundColor: "white", borderRadius: 1, border: "1px solid #e0e0e0" }}>
                  <Typography variant="body2" color="black" sx={{ whiteSpace: "pre-wrap" }}>
                    {remarksDialog.applicant.rejection_reason || "No reason provided"}
                  </Typography>
                </Box>
              </Box>
            </Box>
          )}
        </DialogContent>
        <DialogActions sx={{ p: 2, pt: 0 }}>
          <Button
            onClick={handleCloseRemarksDialog}
            variant="contained"
            sx={{
              backgroundColor: "#1d82f5",
              color: "white",
              "&:hover": { backgroundColor: "#1565c0" },
            }}
          >
            Close
          </Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
};

export default ViewMoreVacanciesCreated;